import React, { useEffect } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const LineChartExpenses = ({ keyId, title, data, xAxis, lstRenderLine }) => {

    useEffect(() => {

        let ElementId = "chart-expense-" + keyId;
        let chart = am4core.create(ElementId, am4charts.XYChart3D);
        chart.colors.step = 2;


        let charttitle = chart.titles.create();
        charttitle.text = title;
        charttitle.fontWeight = "bold";
        charttitle.marginBottom = 10;
        charttitle.fontSize = 20;
        charttitle.align = "center";
        charttitle.fontWeight = '400';

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = xAxis;
        categoryAxis.renderer.minGridDistance = 15;
        categoryAxis.renderer.labels.template.rotation = -45

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        // valueAxis.min = 0;
        // valueAxis.title.text = "บาท";
        // valueAxis.renderer.ticks.template.length = 5;

        valueAxis.title.text = "ล้านบาท";
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        valueAxis.numberFormatter = new am4core.NumberFormatter();
        valueAxis.numberFormatter.numberFormat = "#.00"; 
        valueAxis.adjustLabelPrecision = false;
        valueAxis.renderer.ticks.template.length = 5;

        function addLine(field, name) {
            let lineSeries = chart.series.push(new am4charts.LineSeries());
            lineSeries.name = name;
            lineSeries.dataFields.valueY = field;
            lineSeries.dataFields.categoryX = xAxis;
            lineSeries.strokeWidth = 3;
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.tensionX = 0.9;
            lineSeries.fillOpacity = 0.2;
            lineSeries.legendSettings.labelText = `[bold {color}]{name}[/]`;
            let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
            bullet.tooltipText = "[#fff font-size: 14px]{categoryX} : [/][#fff font-size: 14px]{valueY.formatNumber('#.00')}[/] [#fff]";

            let labelBullet = lineSeries.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "{valueY.formatNumber('#.00')}";
            labelBullet.dy = -10;

            let circle = bullet.createChild(am4core.Circle);
            circle.radius = 4;
            circle.strokeWidth = 3;
        }

        chart.data = data;

        if (lstRenderLine) {
            lstRenderLine.forEach(element => {
                addLine(element.field, element.name + "")
            });
        }
        chart.cursor = new am4charts.XYCursor()
        chart.legend = new am4charts.Legend();

        return () => {
            chart.dispose();
        };
    }, [data, keyId, lstRenderLine, title, xAxis])


    return (
        <div id={"chart-expense-" + keyId} style={{ width: "100%", height: "500px", border: "1px dashed #CCC", borderRadius: 16 }}></div>
    )
}

export default LineChartExpenses;